import WorkPermitState from '../../WorkPermitState/WorkPermitState';

export const WorkPermitStateRender = (params: any) => {
    return (
        <WorkPermitState state={params?.row?.state} />
    )
}
